/*
 * @dev - model
 * validate field differently depending on the input itself.
 * for more validation using yup
 * - https://github.com/jquense/yup
 */

import * as yup from 'yup';
import moment from 'moment';
import { checkEmail, checkPhoneNumber, checkEmptyString } from 'utils/validate';
import isEqual from 'lodash/isEqual';

export const fieldNames = {
  chat: 'chat',
  fromDateTime: 'fromDateTime',
  toDateTime: 'toDateTime',
  span: 'span',
  hours: 'hours',
};

export const radioFieldLabels = {
  hour: { label: 'Last 12 hours', value: '12' },
  day: { label: 'Last 24 hours', value: '1' },
  week: { label: 'Last 7 days', value: '7' },
  month: { label: 'Last 1 month', value: '30' },
};

export const constraints = yup.object().shape({
  [fieldNames.chat]: yup.string(),
});

export const customFilterSchema = yup.object().shape({
  [fieldNames.date]: yup.string(),
  [fieldNames.hours]: yup.string(),
});

export const validate = values => {
  const errors = {};
  if (values && !values.fromDateTime) {
    errors.fromDateTime = 'Please enter a from date!';
  } else if (values && !values.toDateTime) {
    errors.toDateTime = 'Please enter a to date!';
  } else if (moment(values.fromDateTime) > moment().add(1, 'days')) {
    errors.fromDateTime = "From date cannot be greater than today's date";
  } else if (moment(values.toDateTime) > moment()) {
    errors.toDateTime = "To date cannot be greater than today's date";
  } else if (moment(values.fromDateTime) >= moment(values.toDateTime)) {
    errors.toDateTime = 'To date should be greater than from date!';
  } else if (
    !moment(values.fromDateTime).isBetween(
      moment().subtract(91, 'days'),
      moment().subtract(1, 'days'),
      null,
      '[]'
    )
  ) {
    errors.fromDateTime = 'From date should be within last 3 months';
  }
  return errors;
};

export const validateVisitorInfo = (existingAbvValues, values, setFieldError) => {
  const errors = {};
  const { email, phone, firstName, lastName, company, city, region, country, job } = values || {};
  if (email && !isEqual(email, existingAbvValues.email)) {
    const isInvalid = checkEmail(email.value);
    if (isInvalid) {
      setFieldError(`email.value`, isInvalid);
      errors.email = isInvalid;
    }
  }
  if (phone && !isEqual(phone, existingAbvValues.phone)) {
    const isInvalid = checkPhoneNumber(phone.value);
    if (isInvalid) {
      setFieldError(`phone.value`, isInvalid);
      errors.phone = isInvalid;
    }
  }
  if (firstName && !isEqual(firstName, existingAbvValues.firstName)) {
    const isInvalid = checkEmptyString(firstName.value);
    if (isInvalid) {
      setFieldError(`firstName.value`, isInvalid);
      errors.firstName = isInvalid;
    }
  }
  if (lastName && !isEqual(lastName, existingAbvValues.lastName)) {
    const isInvalid = checkEmptyString(lastName.value);
    if (isInvalid) {
      setFieldError(`lastName.value`, isInvalid);
      errors.lastName = isInvalid;
    }
  }
  if (company && !isEqual(company, existingAbvValues.company)) {
    const isInvalid = checkEmptyString(company.value);
    if (isInvalid) {
      setFieldError(`company.value`, isInvalid);
      errors.company = isInvalid;
    }
  }
  if (city && !isEqual(city, existingAbvValues.city)) {
    const isInvalid = checkEmptyString(city.value);
    if (isInvalid) {
      setFieldError(`city.value`, isInvalid);
      errors.city = isInvalid;
    }
  }
  if (region && !isEqual(region, existingAbvValues.region)) {
    const isInvalid = checkEmptyString(region.value);
    if (isInvalid) {
      setFieldError(`region.value`, isInvalid);
      errors.region = isInvalid;
    }
  }
  if (job && !isEqual(job, existingAbvValues.job)) {
    const isInvalid = checkEmptyString(job.value);
    if (isInvalid) {
      setFieldError(`job.value`, isInvalid);
      errors.job = isInvalid;
    }
  }
  if (country && !isEqual(country, existingAbvValues.country)) {
    const isInvalid = checkEmptyString(country.value);
    if (isInvalid) {
      setFieldError(`country.value`, isInvalid);
      errors.country = isInvalid;
    }
  }
  return errors;
};
